import { ApolloClient } from '@apollo/client';
import { isProductionLikeEnvironment } from '@common/neo.tax';

import { env } from '../utils/env';
import { cache } from './cache';
import { link } from './links';

export const apolloClient = new ApolloClient({
  link,
  cache,
  connectToDevTools: !isProductionLikeEnvironment(env.REACT_APP_NEO_TAX_ENV),
});
